import type {SlamPointCloudRepository} from '@/domain/interfaces/SlamPointCloudRepository';

export class GetSlamPointCloudsByInventoryPlotUuidUseCase {
  constructor(private readonly repository: SlamPointCloudRepository) {}
  async execute(inventoryPlotUuid: string) {
    return this.repository.getByInventoryPlotUuid(inventoryPlotUuid);
  }
}
